module.exports = __webpack_public_path__ + "media/images/loginpage-background-94370f7312a2fc056a2b88b69921bfb8.jpg";